export default __webpack_public_path__ + "static/signUpDesktop-f9be824b8e335da1f9926863674f9e7e.png";